import React from "react";
import { Search, X } from "lucide-react";

export const PianificareFilters = ({
  groups, commessa, onCommessa, provincia, onProvincia, regione, onRegione,
  search, onSearch, plannedFrom, onPlannedFrom, plannedTo, onPlannedTo,
  showPlannedDate = false, testPrefix,
}) => {
  const commesse = groups.map((g) => ({ id: g.commessa_id || "", name: g.commessa_name || "Senza commessa" }));
  const province = [...new Set(groups.flatMap((g) => g.clienti.map((c) => (c.provincia || "").trim().toUpperCase())).filter(Boolean))].sort();
  const regioni = [...new Set(groups.flatMap((g) => g.clienti.map((c) => (c.regione || "").trim())).filter(Boolean))].sort();
  const hasFilters = commessa || provincia || regione || search || plannedFrom || plannedTo;
  return (
    <div className="card-shell p-3 mb-4 flex flex-wrap items-end gap-3" data-testid={`${testPrefix}-filters`}>
      <div className="min-w-[180px]">
        <label className="text-xs font-semibold block mb-1" style={{ color: "var(--text-muted)" }}>Commessa</label>
        <select value={commessa} onChange={(e) => onCommessa(e.target.value)}
          className="w-full px-3 py-2 text-sm rounded-md border outline-none" style={{ borderColor: "var(--border)", background: "#fff" }}
          data-testid={`${testPrefix}-filter-commessa`}>
          <option value="">Tutte le commesse</option>
          {commesse.map((c) => <option key={c.id || "_none"} value={c.id}>{c.name}</option>)}
        </select>
      </div>
      {onRegione && (
        <div className="min-w-[160px]">
          <label className="text-xs font-semibold block mb-1" style={{ color: "var(--text-muted)" }}>Regione</label>
          <select value={regione || ""} onChange={(e) => onRegione(e.target.value)}
            className="w-full px-3 py-2 text-sm rounded-md border outline-none" style={{ borderColor: "var(--border)", background: "#fff" }}
            data-testid={`${testPrefix}-filter-regione`}>
            <option value="">Tutte le regioni</option>
            {regioni.map((r) => <option key={r} value={r}>{r}</option>)}
          </select>
        </div>
      )}
      <div className="min-w-[140px]">
        <label className="text-xs font-semibold block mb-1" style={{ color: "var(--text-muted)" }}>Provincia</label>
        <select value={provincia} onChange={(e) => onProvincia(e.target.value)}
          className="w-full px-3 py-2 text-sm rounded-md border outline-none" style={{ borderColor: "var(--border)", background: "#fff" }}
          data-testid={`${testPrefix}-filter-provincia`}>
          <option value="">Tutte le province</option>
          {province.map((p) => <option key={p} value={p}>{p}</option>)}
        </select>
      </div>
      {showPlannedDate && (
        <>
          <div className="min-w-[140px]">
            <label className="text-xs font-semibold block mb-1" style={{ color: "var(--text-muted)" }}>Pianificato dal</label>
            <input type="date" value={plannedFrom || ""} onChange={(e) => onPlannedFrom(e.target.value)}
              className="w-full px-3 py-2 text-sm rounded-md border outline-none" style={{ borderColor: "var(--border)", background: "#fff" }}
              data-testid={`${testPrefix}-filter-planned-from`} />
          </div>
          <div className="min-w-[140px]">
            <label className="text-xs font-semibold block mb-1" style={{ color: "var(--text-muted)" }}>Pianificato al</label>
            <input type="date" value={plannedTo || ""} onChange={(e) => onPlannedTo(e.target.value)}
              className="w-full px-3 py-2 text-sm rounded-md border outline-none" style={{ borderColor: "var(--border)", background: "#fff" }}
              data-testid={`${testPrefix}-filter-planned-to`} />
          </div>
        </>
      )}
      <div className="flex-1 min-w-[200px]">
        <label className="text-xs font-semibold block mb-1" style={{ color: "var(--text-muted)" }}>Nominativo</label>
        <div className="relative">
          <Search className="w-4 h-4 absolute left-2.5 top-1/2 -translate-y-1/2" style={{ color: "var(--text-muted)" }} />
          <input value={search} onChange={(e) => onSearch(e.target.value)} placeholder="Cerca per nome o cognome…"
            className="w-full pl-8 pr-3 py-2 text-sm rounded-md border outline-none" style={{ borderColor: "var(--border)", background: "#fff" }}
            data-testid={`${testPrefix}-filter-nominativo`} />
        </div>
      </div>
      {hasFilters && (
        <button onClick={() => { onCommessa(""); onProvincia(""); onRegione?.(""); onSearch(""); onPlannedFrom?.(""); onPlannedTo?.(""); }}
          className="btn-secondary text-xs" data-testid={`${testPrefix}-filters-clear`}>
          <X className="w-3.5 h-3.5" /> Azzera filtri
        </button>
      )}
    </div>
  );
};

const plannedDay = (c) => String(c.data_pianificazione || c.planned_at || "").slice(0, 10);

export const filterGroups = (groups, { commessa, provincia, regione, search, plannedFrom, plannedTo }) => {
  const norm = (s) => (s || "").toLowerCase().trim();
  return groups
    .filter((g) => !commessa || (g.commessa_id || "") === commessa)
    .map((g) => ({
      ...g,
      clienti: g.clienti.filter((c) => {
        const pd = plannedDay(c);
        return (!provincia || norm(c.provincia) === norm(provincia)) &&
          (!regione || norm(c.regione) === norm(regione)) &&
          (!search || norm(`${c.nome} ${c.cognome_ragione_sociale}`).includes(norm(search))) &&
          (!plannedFrom || (pd && pd >= plannedFrom)) &&
          (!plannedTo || (pd && pd <= plannedTo));
      }),
    }))
    .filter((g) => g.clienti.length > 0);
};
